import ProjectList from './components/List';
import * as ProjectFn from './components/ProjectFn';

const ProjectFns = {
	OverviewModal: ProjectFn.OverviewModal,
	Overview: ProjectFn.Overview,
	Status: ProjectFn.Status,
	Time: ProjectFn.Time,
	Name: ProjectFn.Name,
	Client: ProjectFn.Client,
};

export { ProjectFns, ProjectList };
